(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-mm-reviews-lazy]';

    const addStylesheet = (href) =>
      new Promise((resolve) => {
        const existing = document.querySelector(`link[href="${href}"]`);
        if (existing) {
          resolve();
          return;
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.addEventListener('load', resolve, { once: true });
        link.addEventListener('error', resolve, { once: true });
        document.head.appendChild(link);
      });

    const loadManifestStyles = async (baseUrl, entryKey) => {
      const response = await fetch(`${baseUrl}manifest.json?v=${Date.now()}`);
      if (!response.ok) throw new Error('Judge.me manifest unavailable');

      const manifest = await response.json();
      const visited = new Set();
      const styles = new Set();

      const collect = (key) => {
        if (!key || visited.has(key)) return;
        visited.add(key);
        const entry = manifest[key];
        if (!entry) return;
        (entry.css || []).forEach((path) => styles.add(new URL(path, baseUrl).href));
        (entry.imports || []).forEach(collect);
      };

      collect(entryKey);
      await Promise.all([...styles].map(addStylesheet));
    };

    const waitForJudgeBase = () =>
      new Promise((resolve, reject) => {
        let attempts = 0;
        const check = () => {
          if (window.jdgm && window.jdgm.CDN_BASE_URL) {
            resolve(window.jdgm.CDN_BASE_URL);
            return;
          }
          attempts += 1;
          if (attempts >= 80) {
            reject(new Error('Judge.me core unavailable'));
            return;
          }
          window.setTimeout(check, 50);
        };
        check();
      });

    const waitForWidget = (root) =>
      new Promise((resolve, reject) => {
        const isReady = () =>
          root.querySelector('.jm-review-widget, .jdgm--done-setup-widget, .jdgm-rev-widg');

        if (isReady()) {
          resolve();
          return;
        }

        const observer = new MutationObserver(() => {
          if (!isReady()) return;
          observer.disconnect();
          window.clearTimeout(timeout);
          resolve();
        });

        observer.observe(root, { childList: true, subtree: true, attributes: true });
        const timeout = window.setTimeout(() => {
          observer.disconnect();
          reject(new Error('Judge.me widget timeout'));
        }, 12000);
      });

    const loadModule = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = src;
        script.addEventListener('load', resolve, { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

    const init = (root) => {
      if (!root || root.dataset.mmReviewsInitialized === 'true') return;
      root.dataset.mmReviewsInitialized = 'true';

      const summary = root.querySelector('[data-mm-reviews-summary]');
      const loadButton = root.querySelector('[data-mm-reviews-load]');
      const fallback = root.querySelector('[data-mm-reviews-fallback]');
      const status = root.querySelector('[data-mm-reviews-status]');
      const widget = root.querySelector('[data-mm-reviews-widget]');
      const template = root.querySelector('[data-mm-reviews-template]');
      const dataElement = root.querySelector('[data-mm-reviews-data]');
      let loading = false;
      let loaded = false;

      if (!summary || !loadButton || !status || !widget || !template) return;

      const mount = async () => {
        if (loading || loaded) return;
        loading = true;
        loadButton.disabled = true;
        status.textContent = status.dataset.loadingLabel;
        status.hidden = false;
        status.classList.add('is-loading');

        try {
          if (!widget.firstElementChild) {
            widget.appendChild(template.content.cloneNode(true));
          }

          window.jdgm = window.jdgm || {};
          window.jdgm.data = window.jdgm.data || {};
          window.jdgm.data.reviewWidget = window.jdgm.data.reviewWidget || {};

          if (dataElement) {
            window.jdgm.data.reviewWidget[dataElement.dataset.productId] = JSON.parse(dataElement.textContent);
          }

          const baseUrl = await waitForJudgeBase();
          const entryPoint = root.dataset.mmReviewsEntryPoint;
          const entryKey = root.dataset.mmReviewsEntryKey;
          await loadManifestStyles(baseUrl, entryKey);

          widget.hidden = false;
          const moduleUrl = new URL(entryPoint, baseUrl).href;
          const existingModule = document.querySelector(`script[src="${moduleUrl}"]`);
          const finalModuleUrl = existingModule
            ? `${moduleUrl}${moduleUrl.includes('?') ? '&' : '?'}mm_lazy=${Date.now()}`
            : moduleUrl;

          await loadModule(finalModuleUrl);
          await waitForWidget(widget);

          loaded = true;
          summary.hidden = true;
          status.hidden = true;
          status.classList.remove('is-loading');
          root.classList.add('is-loaded');
        } catch (error) {
          widget.hidden = true;
          status.textContent = status.dataset.errorLabel;
          status.classList.remove('is-loading');
          fallback.hidden = false;
          loadButton.hidden = true;
        } finally {
          loading = false;
          loadButton.disabled = false;
        }
      };

      loadButton.addEventListener('click', mount);

      if (root.dataset.mmReviewsDesignMode === 'true') {
        mount();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          mount();
        },
        { rootMargin: '0px' }
      );

      observer.observe(root);

      if (window.location.hash === '#reviews' || window.location.hash === '#judgeme_product_reviews') {
        mount();
      }
    };

    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
